import * as React from 'react'

import { type VariantProps, tv } from 'tailwind-variants'

import { cn } from '@/shared/lib/cn'

// eslint-disable-next-line react-refresh/only-export-components
export const badgeVariants = tv({
	base: 'inline-flex items-center justify-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
	variants: {
		variant: {
			default:
				'border-transparent bg-primary text-primary-foreground! group-hover:bg-primary/80 data-loading:text-primary-foreground data-loading:bg-primary group-hover:bg-primary-muted group-active:bg-primary-accent ts-7'
		},
		size: {
			dot: 'w-6 h-6 py-0 px-0'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
})

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

export const Badge = ({
	className,
	variant,
	size = 'dot',
	...props
}: BadgeProps) => {
	return (
		<div
			className={cn(badgeVariants({ variant, size }), className)}
			{...props}
		/>
	)
}
